import { render, staticRenderFns } from "./ParamountNav.vue?vue&type=template&id=55bc05ba&scoped=true&"
import script from "./ParamountNav.vue?vue&type=script&lang=ts&"
export * from "./ParamountNav.vue?vue&type=script&lang=ts&"
import style0 from "./ParamountNav.vue?vue&type=style&index=0&id=55bc05ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc05ba",
  null
  
)

export default component.exports